import { useMaintenanceStatus } from '../hooks';
import { MaintenancePage } from '../components';

/**
 * Full-screen maintenance container.
 * Reads the public maintenance status and renders the maintenance page.
 */
export const MaintenanceContainer = () => {
    const { status } = useMaintenanceStatus();

    return <MaintenancePage message={status.message} />;
};

export default MaintenanceContainer;
